import './Timeline.scss';

import { Profile } from "../Profile/Profile";

export const Timeline = ({columns, data}) => {

    const showData = (value) => {
        if (value === null || value === undefined) {
            return "Отсутствует";
        } else if (Array.isArray(value)) {
            if (value.length > 0) {
                return value.map((item) => `${item.name} ${item.count}`).join(', ');
            } else {
                return "Отсутствует";
            }
        } else {
            return value;
        }
    }

    return (
        <div className="timeline">
            <div className="timeline_container">
                <div className="timeline_content">
                    {data.map((update, index) => (
                        <div key={index} className="timeline_item">
                            <div className="timeline_left">
                                <div className="timeline_dot"></div>
                                <div className="timeline_line"></div>
                            </div>
                            <div className="timeline_right">
                                <div className="timeline_box">
                                    {columns.map((col) =>
                                        update.hasOwnProperty(col.key) ? (
                                            <div key={col.key} className="timeline_field">
                                                <div className="timeline_title">{col.alias || col.name}</div>
                                                <div className="timeline_text">
                                                    {showData(update[col.key])}
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                    <div className={"timeline_user"}>
                                        <Profile
                                            firstName={update.reporter.first_name}
                                            lastName={update.reporter.last_name}
                                            showName={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}